import { setHeaders, setReqOpts, privMemberId, STARS_ENROLLED } from "../utils";

export const subscribeToOffer = async (offerId) => {
  const memberId = localStorage.getItem(privMemberId);
  const payload = JSON.stringify({
    offer_id: offerId,
    accepted: true,
  });
  const headers = setReqOpts("POST", setHeaders(), payload);
  const response = await fetch(`${STARS_ENROLLED}/${memberId}`, headers)
    .then((resp) => {
      if (resp.ok) return resp.json();
      throw new Error("Something went wrong");
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
  return response;
};
